module.exports = __webpack_public_path__ + "static/media/liveEventLogo.c38b91e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hall/liveEventLogo.svg
// module id = 1254
// module chunks = 0